var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'text-white': _vm.textWhite},attrs:{"id":"footer"}},[_vm._v(" © 2021 Nikolai Gust "),_c('span',{staticClass:"impressum-link",on:{"click":function($event){return _vm.$store.commit('impressumOn')}}},[_vm._v("Impressum")])])}
var staticRenderFns = []

export { render, staticRenderFns }